import React from 'react';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import WidgetClassSessions from './WidgetClassSessions';
import WidgetSubscription from './WidgetSubscription';

const AccordionDetailsCourse = ({ subservice, sessionActiveStep, closeModal }) => {
  return (
    <div class="flex overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-1 justify-center items-center w-full md:inset-0 max-h-full bg-black bg-opacity-50">
      <div class="relative p-4 w-full max-w-[720px]">
        <div class="relative bg-white rounded-lg shadow ">
          <div class="flex items-center justify-between p-4 md:p-5 border-b rounded-t">
            <h3 class="text-lg font-semibold text-gray-900">{subservice?.name}</h3>
            <button
              onClick={() => closeModal()}
              type="button"
              class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
              data-modal-toggle="crud-modal"
            >
              <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
              </svg>
              <span class="sr-only">Close modal</span>
            </button>
          </div>
          <div className="p-4 md:p-5">
            {sessionActiveStep === 0 && <WidgetClassSessions gyClass={subservice} />}
            {sessionActiveStep === 1 && <WidgetSubscription gyClass={subservice} closeModal={closeModal} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccordionDetailsCourse;
